/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Directive, ElementRef, HostListener, Input} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
    selector: 'input[numbersOnly]',
    standalone: false
})
export class NumbersOnlyDirective {
    constructor(private elementRef: ElementRef) {}

    @HostListener('input', ['$event'])
    onInputChange = (event: Event): void => {
        const initialValue = this.elementRef.nativeElement.value;
        this.elementRef.nativeElement.value = initialValue.replace(/[^0-9]*/g, '');
        if (initialValue !== this.elementRef.nativeElement.value) {
            event.stopPropagation();
        }
    };
}
